import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabFilter from '@components/tabFilter';
import FeedbackList from '@components/feedbackList';

interface MyFeedbackListPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    thread?: ThreadAction;
    feedbackList?: any[];
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navClick?: Function
    feedbackFilterIndex?: number
}
interface MyFeedbackListPCState {
    loading: boolean;
    error: any
    pageLoaded: any
}
@inject('app', 'site', 'user', 'thread')
@observer
class MyFeedbackListPCPage extends BasePage<MyFeedbackListPCPageProps, MyFeedbackListPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
    };
    componentDidMount() {
        super.componentDidMount();
    }

    // 反馈列表
    renderFeedbackList = () => {
        const { thread, feedbackList, loading, hasMore, onLoadMore, feedbackFilterIndex, navList, navClick } = this.props;
        if (!thread || !thread.listStore) return null;

        const filterList = navList || [];

        return (
            <div className={styles.activityContent}>
                <div className={styles.filterBox}>
                    <TabFilter
                        filterList={filterList}
                        currentIndex={feedbackFilterIndex || 0}
                        filterClick={(_item: any, index: number) => {
                            navClick && navClick(navList[index], index);
                        }}
                    />
                </div>
                <div style={{ marginBottom: 16 }}>
                    <FeedbackList
                        data={feedbackList || []}
                        loading={loading || false}
                        hasMore={hasMore ?? true}
                        emptyIcon={`${BASE_IMG_URL}/common/null.png`}
                        emptyBoxStyle={{ padding: '200px 0 240px' }}
                        namespace="usersFeedbacksList"
                        onLoadMore={onLoadMore}
                        listStore={thread.listStore}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (<div className={styles.wrapper}>
            {this.renderFeedbackList()}
        </div>)
    }
}

export default withRouter(MyFeedbackListPCPage);
